"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function SecureYourLegacy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="secure-your-legacy" className="dark bg-background text-foreground relative w-full overflow-hidden py-24 flex flex-col justify-center items-center min-h-[60vh]">
      {}
      <Separator className="absolute top-0 left-0 w-full bg-primary/40 h-[1px]" />

      {}
      <div className="absolute inset-0 z-0 pointer-events-none opacity-10 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1552867/img/charcoal_texture_bg.png)] bg-cover bg-center mix-blend-overlay" />

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-4 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="max-w-3xl mx-auto space-y-8">
          <h2 className="font-serif text-5xl md:text-6xl text-primary tracking-tight leading-tight">Build Your Legacy</h2>
          
          <p className="text-xl md:text-2xl text-muted-foreground font-light leading-relaxed max-w-2xl mx-auto">Take control of your international future. Create a clear and structured foundation for long-term stability and freedom.</p>

          <div className="pt-4">
            <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 font-semibold text-lg px-8 py-6 h-auto shadow-[0_0_20px_var(--primary)/20] transition-transform hover:scale-105">
              <Link to="#SuccessJurisdictions">
                Request Private Consultation
                <ArrowRight className="ml-2 w-5 h-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <Separator className="absolute bottom-0 left-0 w-full bg-primary/40 h-[1px]" />
    </section>;
}